import React, { ReactNode } from 'react';

import loginImage from 'assets/images/login-image.svg';
import logo from 'assets/images/new_logo.png';
import { ReturnComponentType } from 'common';
import './ExternalBaseComponent.scss';
import { useHandleError } from 'hooks';

type ExternalBaseComponentType = {
  children: ReactNode;
};

export const ExternalBaseComponent = ({
  children,
}: ExternalBaseComponentType): ReturnComponentType => {
  const error = useHandleError();

  return (
    <>
      <div className="ExternalBaseComponent">
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
        <img src={loginImage} alt="image" className="ExternalBaseComponent_Logo" />
        <div className="ExternalBaseComponent_Children">
          <div className="ExternalBaseComponent_Children_Header">
            <img
              src={logo}
              alt="logo"
              className="ExternalBaseComponent_Children_Header_Logo"
            />
          </div>
          {children}
          {error && <div className="ExternalBaseComponent_Children_Error">{error}</div>}
        </div>
      </div>
      <div className="ExternalBaseComponent_MobileMessage">
        <img src={logo} alt="logo" className="ExternalBaseComponent_MobileMessage_Logo" />
        <p>To access your account, please log in from a desktop or laptop.</p>
      </div>
    </>
  );
};
